import { userOutlookClientsStore } from "../store/store";

export default function isPhoneCardDismissed(): boolean {
    return userOutlookClientsStore().isCardDismissed;
}
